/* eslint-disable no-console */
import SiteModal from '../site-modal';

let seenModal = false;

const dealerContactModal = () => {
  // console.log('dealer-contact-modal.js');
  const {
    dealerContactModalDelay,
  } = window;

  const modal = new SiteModal({
    id: 'dealer-contact-modal',
  });

  const isSiteModalOpen = () => {
    const modals = document.querySelectorAll('.modal.modal-visible, .site-modal.modal-visible');
    return modals.length > 0;
  };

  const isSiteModalClosed = () => {
    const timer = setInterval(() => {
      if (!isSiteModalOpen()) {
        clearInterval(timer);
        setTimeout(() => {
          onModalDelayExpired(); /* eslint-disable-line no-use-before-define */
        }, dealerContactModalDelay);
      }
    }, 2000);
  };

  const onModalDelayExpired = () => {
    // console.log('dealer-contact-modal.js, onModalDelayExpired');
    if (seenModal) {
      return;
    }
    // Is there an active modal?
    if (isSiteModalOpen()) {
      // Set up timer to wait until no active modal
      isSiteModalClosed();
      return;
    }
    modal.open();
  };

  setTimeout(() => {
    onModalDelayExpired();
  }, dealerContactModalDelay);
  // Set up sticky dealer cta events
  const stickyDealerCtaBtn = document.querySelector('.sticky-dealer-cta');
  if (stickyDealerCtaBtn) {
    stickyDealerCtaBtn.addEventListener('click', () => {
      seenModal = true;
      modal.open();
    });
  }
};

export default dealerContactModal;
/* eslint-enable no-console */
